import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { showActiveFeedback } from './product-bundle-feedback/product-bundle-feedback';
import { initDescriptionSlider } from './product-bundle-smart-home-control/product-bundle-smart-home-control';
import { initProduct } from '../../snippets/product-base-bundle/product-base-bundle';
import { initBundleInstallation } from './product-bundle-installation/product-bundle-installation';
import YTPlayer from '../../scripts/components/YTPlayer';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});
initProduct();
initBundleInstallation();
initDescriptionSlider();
showActiveFeedback();
YTPlayer.init();
initCollapsibleRows();
